<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card hover to="/commercial">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs3 sm2 md8>
                <v-chip label text-color="white" color="red lighten-2" class="py-2 icon-chip">
                  <v-icon dark>fas fa-shopping-cart</v-icon><span class="headline ml-3 hidden-sm-and-down">Commercial</span>
                </v-chip>
              </v-flex>
              <v-flex xs8 sm9 md3 class="text-md-right">
                <div class="headline">{{indicateurNeuf('Toutes', 'actesRealises')}} Actes</div>
                <div>{{indicateurNeuf('Toutes', 'resasRealises')}} Réservations</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card hover to="/promotion">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs3 sm2 md8>
                <v-chip label text-color="white" color="indigo lighten-2" class="py-2 icon-chip">
                  <v-icon dark>fas fa-building</v-icon><span class="headline ml-3 hidden-sm-and-down">Promotion</span>
                </v-chip>
              </v-flex>
              <v-flex xs8 sm9 md3 class="text-md-right">
                <div class="headline">{{ indicateurPromotion('Toutes', 'PUV') }} PUV</div>
                <div>{{indicateurPromotion('Toutes', 'PUV')/indicateurPromotion('Toutes', 'objectifsPUV') | percent(0, false)}} Objectif</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="user.fullAccess">
        <v-card hover to="/financier">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs3 sm2 md8>
                <v-chip label text-color="white" color="teal lighten-2" class="py-2 icon-chip">
                  <v-icon dark>fas fa-euro-sign</v-icon><span class="headline ml-3 hidden-sm-and-down">Financier</span>
                </v-chip>
              </v-flex>
              <v-flex xs8 sm9 md3 class="text-md-right">
                <div class="headline">{{ indicateurFinancier('tresorerieGroupe')*1000 | currency}}</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="user.fullAccess">
        <v-card hover to="/rh">
          <v-container fluid grid-list-lg>
            <v-layout row align-center>
              <v-flex xs3 sm2 md8>
                <v-chip label text-color="white" color="orange lighten-2" class="py-2 icon-chip">
                  <v-icon dark>fas fa-users</v-icon><span class="headline ml-3 hidden-sm-and-down">RH</span>
                </v-chip>
              </v-flex>
              <v-flex xs8 sm9 md3 class="text-md-right">
                <div class="headline">{{ indicateurRh('effectifs') }} Collaborateurs</div>
                <div>{{ serieRh('arrivees').length }} Arrivées</div>
              </v-flex>
              <v-flex xs1 class="text-xs-right">
                <v-icon color="grey lighten-1">fas fa-angle-right</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'home',
  data(){
    return {
     
    }
  },
  computed: {
    ...mapState([
      'user'
    ]),
    ...mapGetters([
      'indicateurNeuf',
      'indicateurPromotion',
      'indicateurRh',
      'indicateurFinancier',
      'serieRh'
    ])
  }
}
</script>

<style scoped>

</style>
